<script lang="ts" setup>
import { useAppStore } from '@/store/app/app'

const appStore = useAppStore()

watch(
  () => appStore.snackbar.show,
  async (newValue, oldValue) => {
    // Если показываем один (первый) снекбар
    // Или если в очереди нет больше снекбаров
    if ((newValue && !oldValue) || !appStore.snackbarQueue.length) return

    // Если закончили показывать снекбар и в очереди есть еще
    await nextTick()
    // FIFO очередь
    appStore.showSnackbar(appStore.snackbarQueue[0])
    appStore.snackbarQueue.shift()
  },
)
</script>
<template>
  <the-snackbar
    v-model="appStore.snackbar.show"
    :location="appStore.snackbar.location"
    :message="appStore.snackbar.message"
    :type="appStore.snackbar.type"
    :timeout="appStore.snackbar.timeout"
  />
</template>
